import mapKeys from 'lodash/mapKeys';

export default obj => {
  return mapKeys(obj, (v, k) => k.toLowerCase());
};
